import React from 'react';

function SliderInput({ min, max, value, onChange, minLabel, maxLabel }) {
  const current = value !== '' && value !== null ? Number(value) : null;
  const pct = current !== null ? ((current - min) / (max - min)) * 100 : 0;

  return (
    <div className="slider-input">
      <div className="slider-input__track-wrap">
        <input
          type="range"
          className="slider-input__range"
          min={min}
          max={max}
          step={1}
          value={current ?? min}
          onChange={(e) => onChange(e.target.value)}
          style={{
            background: current !== null
              ? `linear-gradient(to right, var(--accent) 0%, var(--accent) ${pct}%, var(--border) ${pct}%, var(--border) 100%)`
              : 'var(--border)',
          }}
        />
      </div>

      <div className="slider-input__info">
        <span className="slider-input__label">{minLabel || min}</span>
        <span className="slider-input__value">
          {current !== null ? current : '—'}
        </span>
        <span className="slider-input__label">{maxLabel || max}</span>
      </div>
    </div>
  );
}

export default SliderInput;
